import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import TextareaFormikInput from "../../../inputs/TextareaFormikInput";
import Assistant from "../../Assistant";
import {loadUsers} from "../../../user/usersAction";
import {postAxis} from "../../../axis/one-axis/oneAxisAction";
import {loadAllAxis} from "../../../axis/all-axis/axisAction";
import ExitButton from "../../../buttons/ExitButton";
import {FormFormik, InputTextFormik} from "../../../inputs/InputStyle";
import CheckboxFormikInput from "../../../inputs/CheckboxFormikInput";
import SelectUserInputFormik from "../../../inputs/SelectUserInputFormik";
import SendFormButton from "../../../buttons/SendFormButton";
import {BaseModal} from "../../../modal/modalStyle";

const AxisFormForCoach = ({ close, name, comment }) => {
    const dispatch = useDispatch();

    const { users } = useSelector((state) => state.users);

    useEffect(() => {
        if (users.length === 0) {
            dispatch(loadUsers());
        }
    }, [dispatch, users.length]);


    const handleSubmit = async (data) => {
        let newData = Object.assign({}, data);
        if (data.toggle === false || data.sponsorId === "") {
            newData.sponsorId = null;
        } else {
            newData.sponsorId = Number(data.sponsorId);
        }
        delete newData.toggle;
        await dispatch(postAxis(newData));

        await dispatch(loadAllAxis());
        close()
    };

    const AxisSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, "Le nom de l'axe est trop court")
            .max(255, "Le nom de l'axe est trop long")
            .required("Le nom de l'axe est requis"),
    });

    return (
                <Modal>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            name:  name ?? "",
                            comment:  comment ?? "",
                            toggle:  false,
                            sponsorId:  "",
                            isStrategic: true,
                        }}
                        validationSchema={AxisSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isValid, isSubmitting, values, setFieldValue }) => (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        gap: 32,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <Form
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            <div>
                                                <label htmlFor="name"> Nom de l'axe * : </label>
                                                <InputTextFormik
                                                    name="name"
                                                    type={"text"}
                                                    placeholder={"Nom de l'axe"}
                                                />
                                                <ErrorMessage
                                                    name="name"
                                                    render={(msg) => (
                                                        <div>
                                                            <p className="error-text"> {msg} </p>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <div className={"flex-col gap-05"}>
                                                <label htmlFor="comment"> Commentaire </label>
                                                <TextareaFormikInput
                                                    name="comment"
                                                    rows="4"
                                                    placeholder="Écrivez votre commentaire"
                                                />
                                                <ErrorMessage
                                                    name="comment"
                                                    render={(msg) => (
                                                        <div>
                                                            <p className="error-text"> {msg} </p>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <div>
                                                <CheckboxFormikInput
                                                    label={"Avec sponsor"}
                                                    name={"toggle"}
                                                />
                                                {values.toggle && (
                                                    <>
                                                        <SelectUserInputFormik
                                                            pilotId={values.sponsorId}
                                                            users={users}
                                                            name={"sponsorId"}
                                                            label={"sponsor"}
                                                            initialUser={""}
                                                        />
                                                        <ErrorMessage
                                                            name="sponsorId"
                                                            render={(msg) => (
                                                                <div>
                                                                    <p className="error-text"> {msg} </p>
                                                                </div>
                                                            )}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                            <SendFormButton
                                                state={isValid && !isSubmitting}
                                                actionName={"Ajouter"}
                                            />
                                        </Form>
                                    </div>
                                </div>
                            </>
                        )}
                    </Formik>
                </Modal>

    );
};

const Modal = styled.div`
  width: 100%;
  height: fit-content;
  overflow: auto;
  gap: 1.5rem;
  padding: 2rem;
  position: unset;
  

  @media (min-width: 768px) {
    height: fit-content;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    margin-top:30px;
  }
`;

const Form = styled(FormFormik)`
  gap: 2rem;
`;


export default AxisFormForCoach;
